import React, { useState, useEffect } from 'react';
import '../styles/components/ImageCarousel.css';

// Import all images from MEDC PICTURES PLACEHOLDER folder
import img1 from '../images/MEDC PICTURES PLACEHOLDER/1.png';
import img2 from '../images/MEDC PICTURES PLACEHOLDER/2.png';
import img3 from '../images/MEDC PICTURES PLACEHOLDER/3.png';
import img4 from '../images/MEDC PICTURES PLACEHOLDER/4.png';
import img5 from '../images/MEDC PICTURES PLACEHOLDER/5.png';
import img6 from '../images/MEDC PICTURES PLACEHOLDER/6.png';
import img7 from '../images/MEDC PICTURES PLACEHOLDER/7.png';
import img8 from '../images/MEDC PICTURES PLACEHOLDER/8.png';
import img9 from '../images/MEDC PICTURES PLACEHOLDER/9.png';

const ImageCarousel = ({ showOverlay = true }) => {
  const images = [img1, img2, img3, img4, img5, img6, img7, img8, img9];
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  useEffect(() => {
    if (isPaused) return;
    
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 4000); // Change image every 4 seconds

    return () => clearInterval(interval);
  }, [images.length, isPaused]);

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  return (
    <div 
      className="image-carousel"
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
    >
      <div className="carousel-container">
        {images.map((img, index) => (
          <div
            key={index}
            className={`carousel-slide ${index === currentIndex ? 'active' : ''}`}
          >
            <img src={img} alt={`MEDC Gallery ${index + 1}`} />
          </div>
        ))}
      </div>
      
      {showOverlay && (
        <div className="carousel-overlay">
          <div className="overlay-number">Since 1997</div>
          <div className="overlay-text">Est. October 29</div>
        </div>
      )}
    </div>
  );
};

export default ImageCarousel;

